<template>
  <div id="main-event">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center pt-3">
        <div class="title-content-package">EVENT</div>
        <router-link
          :to="{ name: 'Event' }"
          class="text-muted fs-14 fw-lighter d-flex align-items-center gap-1"
        >
          <span>Lihat Semua</span>
          <svg width="6" height="12" viewBox="0 0 9 18" fill="#6c757d" xmlns="http://www.w3.org/2000/svg">
<path d="M0.910097 17.67C0.720097 17.67 0.530098 17.6 0.380098 17.45C0.0900977 17.16 0.0900977 16.68 0.380098 16.39L6.9001 9.87002C7.3801 9.39002 7.3801 8.61002 6.9001 8.13002L0.380098 1.61002C0.0900977 1.32002 0.0900977 0.84002 0.380098 0.55002C0.670098 0.26002 1.1501 0.26002 1.4401 0.55002L7.9601 7.07002C8.4701 7.58002 8.7601 8.27002 8.7601 9.00002C8.7601 9.73002 8.4801 10.42 7.9601 10.93L1.4401 17.45C1.2901 17.59 1.1001 17.67 0.910097 17.67Z" fill="#6c757d"/>
          </svg>
        </router-link>
      </div>
      <div class="row flex-nowrap overflow-auto pb-3 pb-md-5">
        <Loading v-if="loading.getEvent" />
        <Empty v-else-if="listEvent.length === 0" :message="'Saat ini belum ada event untuk Anda.'"/>
        <div v-else v-for="event in listEvent" :key="event.id" class="col-8 col-md-4 pt-2 pb-2">
          <div class="card border-0 shadow" @click="handleOnClick(event)">
            <div class="card-body p-0">
              <div class="d-flex flex-column">
                <div class="img-wrapper">
                  <img class="icon-vouchers" :src="event.gambar_url">
                  <span class="badge-harga" :class="event.is_gratis === 't' ? 'badge-gratis' : 'badge-bayar'">
                    {{ event.label_harga }}
                  </span>
                  <span v-if="event.label_sisa_kuota" class="badge-kuota">
                    {{ event.label_sisa_kuota }}
                  </span>
                </div>
                <div class="pt-2 pb-3 px-3">
                  <h5 class="card-title fw-700">
                    {{ event.judul }}
                  </h5>
                  <div class="event-meta text-muted fs-13 mt-1" v-if="event.tgl_mulai">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    {{ formatTanggal(event.tgl_mulai) }}
                  </div>
                  <div class="event-meta text-muted fs-13 mt-1" v-if="event.lokasi">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    {{ event.lokasi }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEvent, listEvent, loading } from '@/core/event'
import { onMounted } from 'vue'
import Loading from '@/components/utility/Loading'
import Empty from '@/components/utility/Empty'
import { useRouter } from 'vue-router'

export default {
  components: {
    Loading, Empty
  },

  setup () {
    const router = useRouter()

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']

    const formatTanggal = (tgl) => {
      if (!tgl) return ''
      const date = new Date(tgl.replace(' ', 'T'))
      const day = date.getDate()
      const month = months[date.getMonth()]
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${day} ${month} ${year} · ${hours}:${minutes} WIB`
    }

    const handleOnClick = (event) => {
      router.push({
        name: 'EventDetail',
        params: { id: event.id }
      })
    }

    onMounted(async () => {
      await getEvent()
    })

    return {
      loading,
      listEvent,
      handleOnClick,
      formatTanggal
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-vouchers {
  width: 100%;
  height: 210px;
  display: block;
  object-fit: contain;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.img-wrapper {
  position: relative;

  .badge-harga {
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    line-height: 1.4;

    &.badge-gratis {
      background-color: #198754;
      color: #fff;
    }

    &.badge-bayar {
      background-color: #fff;
      color: var(--color-primary, #0d6efd);
      box-shadow: 0 1px 4px rgba(0,0,0,0.15);
    }
  }

  .badge-kuota {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    line-height: 1.4;
    background-color: #fff3cd;
    color: #856404;
    box-shadow: 0 1px 4px rgba(0,0,0,0.15);
  }
}

.card {
  border-radius: 10px;
  cursor: pointer;
  height: 100%;

  .card-title {
    font-size: 16px;
    line-height: 22px;

    @media (max-width: 580px) {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 2px;
    }
  }
}

.event-meta {
  display: flex;
  align-items: center;
  gap: 5px;

  svg {
    flex-shrink: 0;
  }
}

.title-content-package {
  font-size: 22px;
  color: #1A202C;

  @media (max-width: 580px) {
    font-size: 16px;
  }
}
</style>
